<template>
    <div class="config-manager apply-bootstrap">
        <layout-container v-if="layoutId" :c-id="layoutId" :editor-enabled="enableEditor"></layout-container>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import "@common/syncfusionCss";

const ecDashboardComponent = {
    data() {
        return {
            enableEditor: false
        };
    },
    computed: {
        layoutId() {
            return DASHBOARD_LAYOUT_ID;
        }
    },
    components: {
        layoutContainer: defineAsyncComponent(() => import('@common/layoutContainer/layoutContainer.vue'))
    },
};

export default ecDashboardComponent;
</script>

<style lang="css">
@import "~@common/global.css";
@import "~@common/styles/utilities.css";

.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
    padding: 0;
}

#ecDashboard {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
}
</style>
